import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import createUserGroupService from '../../services/userGroups/createUserGroupService';
import UserGroupForm from './UserGroupForm';
import { mapFormToUserGroup } from '../../helpers/userGroups/mapFormToUserGroup';

const EMPTY_USER_GROUP = { name: '' };

const NewUserGroup = ({
  open,
  urlRoot,
  organisationId,
  dispatchCreateUserGroupPost,
  createUserGroupFetch,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    body =>
      dispatchCreateUserGroupPost(
        organisationId,
        mapFormToUserGroup(body),
        () => navigate(`${urlRoot}/user-groups`),
        undefined,
        t
      ),
    [dispatchCreateUserGroupPost, organisationId, urlRoot, navigate, t]
  );

  if (!open) return null;

  return (
    <UserGroupForm
      open={open}
      organisationId={organisationId}
      header={t('addUserGroup')}
      onSubmit={handleSubmit}
      submitProcessing={createUserGroupFetch.pending}
      returnRoute={`${urlRoot}/user-groups`}
      cancelRoute={`${urlRoot}/user-groups`}
      data={EMPTY_USER_GROUP}
    />
  );
};

NewUserGroup.propTypes = {
  dispatchCreateUserGroupPost: PropTypes.func.isRequired,
  createUserGroupFetch: PropTypes.object.isRequired,
  urlRoot: PropTypes.string.isRequired,
  organisationId: PropTypes.string.isRequired,
  open: PropTypes.bool,
};

NewUserGroup.defaultProps = { open: false };

export default createUserGroupService(NewUserGroup);
